import React, { useEffect, useState } from 'react';
import { Table, Select, DatePicker, Button, Spin } from 'antd';
import { message } from '../utils/antdMessage';
import apiFetch from '../utils/apiFetch'; // 假设有统一的API请求工具
import dayjs from 'dayjs';
import './History.css'; // 可选：自定义样式

/**
 * 轨迹查询页面
 * 功能：按设备/人员查询历史轨迹，展示轨迹列表和地图
 */
const { RangePicker } = DatePicker;

const History = () => {
  // 设备列表
  const [devices, setDevices] = useState([]);
  // 选中的设备ID
  const [selectedDevice, setSelectedDevice] = useState(null);
  // 选中的时间范围
  const [dateRange, setDateRange] = useState([]);
  // 轨迹数据
  const [tracks, setTracks] = useState([]);
  // 加载状态
  const [loading, setLoading] = useState(false);

  // 获取设备列表
  const fetchDevices = async () => {
    try {
      const res = await apiFetch('/api/device/list');
      const data = await res.json();
      if (data.success) {
        setDevices(data.devices);
      }
    } catch (e) {
      message.error('获取设备列表失败');
    }
  };

  // 查询轨迹
  const fetchTracks = async () => {
    if (!selectedDevice || !dateRange.length) {
      message.warning('请选择设备和时间范围');
      return;
    }
    setLoading(true);
    try {
      const [start, end] = dateRange;
      const res = await apiFetch(`/api/history/track?device_id=${selectedDevice}&start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`);
      const data = await res.json();
      if (data.success) {
        setTracks(data.tracks);
      } else {
        message.error('查询失败');
      }
    } catch (e) {
      message.error('网络错误');
    }
    setLoading(false);
  };

  // 页面加载时获取设备
  useEffect(() => {
    fetchDevices();
  }, []);

  // 表格列定义
  const columns = [
    { title: '时间', dataIndex: 'recorded_at', key: 'recorded_at' },
    { title: '经度', dataIndex: 'longitude', key: 'longitude' },
    { title: '纬度', dataIndex: 'latitude', key: 'latitude' },
    { title: '速度', dataIndex: 'speed', key: 'speed' },
    { title: '电量', dataIndex: 'battery_level', key: 'battery_level' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>轨迹查询</h2>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
        <Select
          style={{ width: 200 }}
          placeholder="选择设备"
          value={selectedDevice}
          onChange={setSelectedDevice}
          options={devices.map(d => ({ label: d.name, value: d.id }))}
        />
        <RangePicker
          value={dateRange}
          onChange={setDateRange}
          allowClear={false}
        />
        <Button type="primary" onClick={fetchTracks}>查询</Button>
      </div>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={tracks}
          rowKey="id"
          bordered
          pagination={{ pageSize: 20 }}
          scroll={{ x: true }}
        />
      </Spin>
      {/* 轨迹地图可后续集成Mapbox或高德地图 */}
    </div>
  );
};

export default History; 